<template>
  <div class="permission-page">
    <a-modal
      class="permissions-modal"
      width="1100px"
      title="权限分配"
      :visible="visible"
      :maskClosable="false"
      @ok="handleSave"
      @cancel="handleClose"
    >
      <a-tabs :activeKey="activeKey" @change="changeTabs">
        <a-tab-pane key="1" tab="EBA设备管理系统">
          <div class="member-permissions">
            <a-checkbox
              :indeterminate="
                Object.keys(iotSelecteds).length > 0 &&
                Object.keys(iotSelecteds).length < iotTreeLength
              "
              :checked="
                iotTreeLength &&
                Object.keys(iotSelecteds).length === iotTreeLength
              "
              @change="(e) => handleIotSelectAll(e.target.checked)"
            >
              全选/反选
            </a-checkbox>
            <div class="menuList">
              <MenuItem
                v-for="(item, index) in iotRuleArr"
                :treeRoot="iotTreeRoot"
                :key="index"
                :menuOneNode="item"
                :selecteds="iotSelecteds"
                @select="checkIotSelect"
                @selectMenuAll="selectIotMenuAll"
              />
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="EBA运营管理系统">
          <div class="member-permissions">
            <a-checkbox
              :indeterminate="
                Object.keys(ebaSelecteds).length > 0 &&
                Object.keys(ebaSelecteds).length < ebaTreeLength
              "
              :checked="
                ebaTreeLength > 0 &&
                Object.keys(ebaSelecteds).length === ebaTreeLength
              "
              @change="(e) => handleEbaSelectAll(e.target.checked)"
            >
              全选/反选
            </a-checkbox>
            <div class="menuList">
              <MenuItem
                v-for="(item, index) in ebaRuleArr"
                :treeRoot="ebaTreeRoot"
                :key="index"
                :menuOneNode="item"
                :selecteds="ebaSelecteds"
                @select="checkEbaSelect"
                @selectMenuAll="selectEbaMenuAll"
              />
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" tab="EBA人员管理系统">
          <div class="member-permissions">
            <a-checkbox
              :indeterminate="
                Object.keys(memberSelecteds).length > 0 &&
                Object.keys(memberSelecteds).length < memberTreeLength
              "
              :checked="
                memberTreeLength > 0 &&
                Object.keys(memberSelecteds).length === memberTreeLength
              "
              @change="(e) => handleMemberSelectAll(e.target.checked)"
            >
              全选/反选
            </a-checkbox>
            <div class="menuList">
              <MenuItem
                v-for="(item, index) in memberRuleArr"
                :treeRoot="memberTreeRoot"
                :key="index"
                :menuOneNode="item"
                :selecteds="memberSelecteds"
                @select="checkMemberSelect"
                @selectMenuAll="selectMemberMenuAll"
              />
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
  </div>
</template>
<script>
import eventStatusMixin from "@/mixins/eventStatus";
import MenuItem from "./component/MenuOneItem.vue";
import TreeModel from "tree-model";
import { authAssignUpdate, authModuleCustomList } from "./service";
export default {
  mixins: [eventStatusMixin],
  components: {
    MenuItem,
  },
  props: {
    memberRoleObj: {
      type: Object,
    },
    ebaRoleObj: {
      type: Object,
    },
    iotRoleObj: {
      type: Object,
    },
    selectedKeys: {
      type: Array,
    },
  },
  data() {
    return {
      visible: false,
      memberRuleArr: [],
      memberSelecteds: {},
      memberTreeRoot: null,
      memberTreeLength: 0,

      ebaRuleArr: [],
      ebaSelecteds: {},
      ebaTreeRoot: null,
      ebaTreeLength: 0,

      iotRuleArr: [],
      iotSelecteds: {},
      iotTreeRoot: null,
      iotTreeLength: 0,

      activeKey: "1",
    };
  },
  mounted() {},
  methods: {
    changeTabs(key) {
      this.activeKey = key;
    },
    openModal() {
      this.getAuthTreeData();
      this.treeRootDATA();
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
      this.memberSelecteds = {};
      this.iotSelecteds = {};
      this.ebaSelecteds = {};
    },
    async getAuthTreeData() {
      try {
        const params = {
          authRoleId: this.selectedKeys[0],
        };

        const res = await authModuleCustomList.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          const data = res.data;
          const tree = new TreeModel({
            childrenPropertyName: "authModulePojoList",
          });
          data.map((item) => {
            let selects = {};
            const treeRoot = tree.parse(item);
            let arr = treeRoot.all(function (node) {
              return node.parent;
            });
            arr.map((item) => {
              selects[item.model.id] = true;
            });
            if (item.id === 12) {
              this.iotSelecteds = selects;
            } else if (item.id === 13) {
              this.memberSelecteds = selects;
            } else if (item.id === 13) {
              this.ebaSelecteds = selects;
            }
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    treeRootDATA() {
      const tree = new TreeModel({
        childrenPropertyName: "authModulePojoList",
      });
      const memberTreeRoot = tree.parse(this.memberRoleObj);
      const ebaTreeRoot = tree.parse(this.ebaRoleObj);
      const iotTreeRoot = tree.parse(this.iotRoleObj);

      this.memberTreeRoot = memberTreeRoot;
      this.memberRuleArr = memberTreeRoot.model.authModulePojoList;
      this.memberTreeLength = memberTreeRoot.all(function (node) {
        return node.parent;
      }).length;

      this.ebaTreeRoot = ebaTreeRoot;
      this.ebaRuleArr = ebaTreeRoot.model.authModulePojoList;
      this.ebaTreeLength = ebaTreeRoot.all(function (node) {
        return node.parent;
      }).length;

      this.iotTreeRoot = iotTreeRoot;
      this.iotRuleArr = iotTreeRoot.model.authModulePojoList;
      this.iotTreeLength = iotTreeRoot.all(function (node) {
        return node.parent;
      }).length;
    },
    menuLengthData(list) {
      let count = 0;
      const trvData = (data) => {
        if (Array.isArray(data.children)) {
          count = count + list.children.length;
          data.children.map((item) => {
            if (Array.isArray(item.children)) {
              trvData(item);
            }
          });
        }
      };
      trvData(list);
      return count;
    },
    checkMemberSelect(id, checked) {
      //console.log(id,checked)
      let selecteds = { ...this.memberSelecteds };
      if (checked) {
        selecteds[id] = true;
      } else {
        delete selecteds[id];
      }
      let parentKey = this.searchParent(
        this.memberTreeRoot,
        id,
        checked,
        selecteds
      );
      this.memberSelecteds = parentKey;
    },
    selectMemberMenuAll(ids, checked, id) {
      let selecteds = { ...this.memberSelecteds };
      if (checked) {
        ids.map((item) => {
          selecteds[item] = true;
        });
      } else {
        ids.map((item) => {
          delete selecteds[item];
        });
      }
      if (id !== 13) {
        let parentKey = this.searchParent(
          this.memberTreeRoot,
          id,
          checked,
          selecteds
        );
        this.memberSelecteds = parentKey;
      } else {
        this.memberSelecteds = selecteds;
      }
    },
    handleMemberSelectAll(checked) {
      let selecteds = {};
      let nodeArr = this.memberTreeRoot.all(function (node) {
        return node.parent;
      });
      if (checked) {
        nodeArr.map((item) => {
          selecteds[item.model.id] = true;
        });
      }
      this.memberSelecteds = selecteds;
    },
    checkIotSelect(id, checked) {
      //console.log(id,checked)
      let selecteds = { ...this.iotSelecteds };
      if (checked) {
        selecteds[id] = true;
      } else {
        delete selecteds[id];
      }
      let parentKey = this.searchParent(
        this.iotTreeRoot,
        id,
        checked,
        selecteds
      );
      this.iotSelecteds = parentKey;
    },
    selectIotMenuAll(ids, checked, id) {
      let selecteds = { ...this.iotSelecteds };
      if (checked) {
        ids.map((item) => {
          selecteds[item] = true;
        });
      } else {
        ids.map((item) => {
          delete selecteds[item];
        });
      }
      if (id !== 12) {
        let parentKey = this.searchParent(
          this.iotTreeRoot,
          id,
          checked,
          selecteds
        );
        this.iotSelecteds = parentKey;
      } else {
        this.iotSelecteds = selecteds;
      }
    },
    handleIotSelectAll(checked) {
      let selecteds = {};
      let nodeArr = this.iotTreeRoot.all(function (node) {
        return node.parent;
      });
      if (checked) {
        nodeArr.map((item) => {
          selecteds[item.model.id] = true;
        });
      }
      this.iotSelecteds = selecteds;
    },
    checkEbaSelect(id, checked) {
      //console.log(id,checked)
      let selecteds = { ...this.ebaSelecteds };
      if (checked) {
        selecteds[id] = true;
      } else {
        delete selecteds[id];
      }
      let parentKey = this.searchParent(
        this.ebaTreeRoot,
        id,
        checked,
        selecteds
      );
      this.ebaSelecteds = parentKey;
    },
    selectIEbaMenuAll(ids, checked, id) {
      let selecteds = { ...this.ebaSelecteds };
      if (checked) {
        ids.map((item) => {
          selecteds[item] = true;
        });
      } else {
        ids.map((item) => {
          delete selecteds[item];
        });
      }
      if (id !== 12) {
        let parentKey = this.searchParent(
          this.ebaTreeRoot,
          id,
          checked,
          selecteds
        );
        this.ebaSelecteds = parentKey;
      } else {
        this.ebaSelecteds = selecteds;
      }
    },
    handleEbaSelectAll(checked) {
      let selecteds = {};
      let nodeArr = this.ebaTreeRoot.all(function (node) {
        return node.parent;
      });
      if (checked) {
        nodeArr.map((item) => {
          selecteds[item.model.id] = true;
        });
      }
      this.ebaSelecteds = selecteds;
    },
    searchParent(treeRoot, id, checked, selectedObj) {
      const selecteds = { ...selectedObj };
      let nodes = treeRoot.first(function (node) {
        return node.model.id === id;
      });
      console.log("nodes", nodes, selecteds);
      const parentTrv = (tmps) => {
        if (tmps && tmps.parent) {
          if (checked) {
            selecteds[tmps.model.id] = true;
          } else {
            let arr = tmps.all(function (node) {
              return node.parent;
            });
            console.log(arr);
            if (
              !arr.some((item) => {
                return (
                  item.model.id !== tmps.model.id &&
                  selecteds[item.model.id] == true
                );
              })
            ) {
              console.log("de", tmps.model.id);
              delete selecteds[tmps.model.id];
            }
          }
          parentTrv(tmps.parent);
        }
      };
      if (nodes && nodes.parent) {
        parentTrv(nodes.parent);
      }
      console.log("key", selecteds);
      return selecteds;
    },
    async handleSave() {
      if (this.hasEventState("handleSave")) return;
      try {
        this.addEventState("handleSave");
        let memberIds = Object.keys(this.memberSelecteds);
        let iotIds = Object.keys(this.iotSelecteds);
        let ebaIds = Object.keys(this.ebaSelecteds);
        let authModuleIds = [];
        if (memberIds.length > 0) {
          authModuleIds.push(13);
        }
        if (iotIds.length > 0) {
          authModuleIds.push(12);
        }
        if (ebaIds.length > 0) {
          authModuleIds.push(14);
        }
        const params = {
          authRoleId: this.selectedKeys[0],
          authModuleIds: authModuleIds.concat(memberIds, iotIds, ebaIds),
        };

        const res = await authAssignUpdate.request(params, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          this.handleClose();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("handleSave");
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]
.member-permissions {
  > .ant-checkbox-wrapper {
  }
  > .menuList {
    margin-top: .convertPxToDesighVH(20) [];
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}
</style>
